import React, { Component } from "react";
import { connect } from "react-redux";
import { Platform } from "react-native";
import { Navigator } from "router";

import routes from "router/routes.web";

class BaseProtectedRoute extends Component {
  componentDidMount = () => {
    const paths = Object.keys(routes);
    if (Platform.OS === "web") {
      if (
        paths.indexOf(window.location.hash[0]) !== -1 ||
        paths.indexOf(window.location.pathname.substr(1)) !== -1
      ) {
        return;
      }
    }

    const { rehydrated } = this.props;
    if (!rehydrated) {
      Navigator.jumpTo("loading");
    }
  };
  render = () => this.props.children;
}

const mapStateToProps = state => {
  return {
    rehydrated: state.loading.rehydrated,
  };
};

export const ProtectedRoute = connect(mapStateToProps)(BaseProtectedRoute);
